// Show clips ("sarjan ääni · oma tallenne"): the users' own recordings of a show line, captured
// while they watch an episode (routes/ShowAudio.tsx). Stored like every private recording
// (POST /api/recordings, private R2) with the target "show:<dialogueId>"; the target prefix is the
// source label, so a show clip is never mistaken for Peterson's or for a pronunciation take.
// Never "official", never public.

export const SHOW_PREFIX = 'show:';

/** "show:<dialogueId>" for a dialogue line. */
export function showTarget(dialogueId: string): string {
  return `${SHOW_PREFIX}${dialogueId}`;
}

/** The dialogue id of a show-clip target, or null for any other target. */
export function showLineId(target: string): string | null {
  return target.startsWith(SHOW_PREFIX) && target.length > SHOW_PREFIX.length ? target.slice(SHOW_PREFIX.length) : null;
}

export const isShowTarget = (target: string): boolean => showLineId(target) !== null;

/** Where a private recording's audio is served (behind login; cached by the service worker). */
export function recordingAudioUrl(id: string): string {
  return `/api/recordings/${encodeURIComponent(id)}/audio`;
}

/** Audio lists mix Peterson's file names ("Kelitis.mp3") with recording URLs ("/api/recordings/…"). */
export const isRecordingUrl = (src: string): boolean => src.startsWith('/api/recordings/');
